<template>
	<div id="container">
		<div class="search-container">
			<div class="search-input-group">
				<input type="text" v-model="searchLockNo" placeholder="输入车锁编号搜索" class="search-input">
				<button @click="searchLock" class="search-button">搜索</button>
			</div>
		</div>
		<div class="search-tip">如果查询到多个车锁，再次点击搜索跳转下一个车锁位置</div>
		<div id="map_view"></div>
	</div>
</template>
<script>
export default {
	data() {
		return {
			lockDeviceList: [],
			geometrieList: [],
			labelGeometries: [],
			infoWindows: [],
			map: null,
			markerLayer: null,
			labelLayer: null,
			searchLockNo: '',
			currentSearchIndex: -1,
			matchingLocks: []
		}
	},
	mounted() {
		// 先初始化地图和标记层
		this.initMap();
		// 然后加载数据
		this.getLockDeviceList();
	},
	beforeDestroy() {
		// 组件销毁时清理地图资源
		if (this.map) {
			this.map.destroy();
			this.map = null;
		}
	},
	methods: {
		initMap() {
			// 如果地图已存在，先销毁
			if (this.map) {
				this.map.destroy();
			}
			
			//定义地图中心点坐标
			var center = new TMap.LatLng(32.902652, 117.440006)
			//定义map变量，调用 TMap.Map() 构造函数创建地图
			this.map = new TMap.Map(document.getElementById('map_view'), {
				center: center,//设置地图中心点坐标
				zoom: 15,   //设置地图缩放级别
				// pitch: 43.5,  //设置俯仰角
				// rotation: 45    //设置地图旋转角度
			});
			
			// 创建并初始化MultiMarker
			this.markerLayer = new TMap.MultiMarker({
				map: this.map,
				styles: {
					"bicycleStyle": new TMap.MarkerStyle({
						width: 40,
						height: 40,
						src: require('@/assets/image/markers.png'),
						anchor: { x: 20, y: 40 }
					}),
					"electricStyle": new TMap.MarkerStyle({
						width: 40,
						height: 40,
						src: require('@/assets/image/diandongche.png'),
						anchor: { x: 20, y: 40 }
					})
				},
				geometries: []
			});
			
			// 创建并初始化MultiLabel
			this.labelLayer = new TMap.MultiLabel({
				map: this.map,
				styles: {
					"labelStyle": new TMap.LabelStyle({
						position: "top",
						offset: { x: 0, y: -50 },
						size: 13,
						color: "#3CA757",
						backgroundColor: "#fff",
						width: 120,
						height: 20,
						borderColor: "#3CA757",
						borderWidth: 1,
						borderRadius: 4,
						padding: 5,
						enableCollision: false
					})
				},
				geometries: []
			});
			
			console.log('Map initialized successfully');
			console.log('Marker layer created:', this.markerLayer);
			console.log('Label layer created:', this.labelLayer);
		},
		getLockDeviceList() {
			// 清空之前的数据
			this.geometrieList = [];
			this.labelGeometries = [];
			
			this.$http.get('/device/manager/getMapLockDevice').then((res) => {
				if (res.data.code == 200) {
					console.log("res: ", res)
					this.lockDeviceList = res.data.data;
					for (let index in this.lockDeviceList) {
						if (this.lockDeviceList[index].longitude == null || this.lockDeviceList[index].latitude == null) {
							continue;
						}
						
						// 获取车锁编号
						const lockNo = this.lockDeviceList[index].imei || this.lockDeviceList[index].qrNumber || "未知编号";
						
						// 根据车锁类型选择样式
						const bicycleType = this.lockDeviceList[index].bicycleType || 1;
						const styleId = bicycleType === 2 ? 'electricStyle' : 'bicycleStyle';
						const position = new TMap.LatLng(this.lockDeviceList[index].latitude, this.lockDeviceList[index].longitude);
						
						// 创建标记
						this.geometrieList.push(
							{
								id: index,
								styleId: styleId,
								position: position,
								properties: {
									title: lockNo,
									lockNo: lockNo
								}
							}
						);
						
						// 创建标签
						this.labelGeometries.push(
							{
								id: `label_${index}`,
								styleId: 'labelStyle',
								position: position,
								content: lockNo
							}
						);
					}
					console.log("geometrieList: ", this.geometrieList);
					console.log("labelGeometries: ", this.labelGeometries);
					
					// 更新标记层和标签层
					if (this.markerLayer) {
						this.markerLayer.setGeometries(this.geometrieList);
						console.log('车锁标记添加成功');
					}
					
					if (this.labelLayer) {
						this.labelLayer.setGeometries(this.labelGeometries);
						console.log('车锁编号标签添加成功');
					}
					
					return;
				}
				this.$message.error(res.data.msg)
			})
		},
		searchLock() {
			if (!this.searchLockNo) {
				this.$message.warning('请输入车锁编号');
				return;
			}
			
			// 模糊查找匹配的车锁
			this.matchingLocks = this.lockDeviceList.filter(device => {
				if (!device.latitude || !device.longitude) {
					return false;
				}
				const lockNo = device.imei || device.qrNumber || "未知编号";
				return lockNo.includes(this.searchLockNo);
			});
			
			if (this.matchingLocks.length > 0) {
				// 增加搜索索引，循环遍历匹配结果
				this.currentSearchIndex = (this.currentSearchIndex + 1) % this.matchingLocks.length;
				const currentLock = this.matchingLocks[this.currentSearchIndex];
				
				// 创建位置对象
				const position = new TMap.LatLng(currentLock.latitude, currentLock.longitude);
				// 移动地图中心到该车锁位置
				this.map.setCenter(position);
				// 调整地图缩放级别
				this.map.setZoom(15);
				
				// 显示搜索结果信息
				const lockNo = currentLock.imei || currentLock.qrNumber || "未知编号";
				this.$message.success(`找到车锁 ${lockNo}，已定位到地图中心 (${this.currentSearchIndex + 1}/${this.matchingLocks.length})`);
			} else {
				// 重置搜索索引
				this.currentSearchIndex = -1;
				this.$message.error('未找到匹配的车锁编号');
			}
		},
		// switchToSatelliteMap() {
		// 	map.setMapTypeId(qq.maps.MapTypeId.SATELLITE);
		// }
	},
}

</script>

<style scoped>
#container {
	position: relative;
	width: 100%;
	height: 100vh;
	min-height: 600px;
}

.search-container {
	position: absolute;
	top: 20px;
	left: 20px;
	z-index: 9999;
	background-color: white;
	padding: 10px;
	border-radius: 4px;
	box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
	display: flex;
	align-items: center;
	pointer-events: auto;
}

.search-input-group {
	display: flex;
	align-items: center;
}

.search-tip {
	position: absolute;
	top: 75px;
	left: 20px;
	z-index: 9999;
	font-size: 12px;
	color: #666;
	white-space: nowrap;
	pointer-events: none;
	background-color: rgba(255, 255, 255, 0.9);
	padding: 4px 8px;
	border-radius: 4px;
	box-shadow: 0 1px 3px rgba(85, 84, 84, 0.1);
}

.search-input {
	width: 160px;
	padding: 6px 10px;
	border: 1px solid #ddd;
	border-radius: 4px;
	margin-right: 8px;
	font-size: 12px;
}

.search-button {
	padding: 6px 12px;
	background-color: #3CA757;
	color: white;
	border: none;
	border-radius: 4px;
	cursor: pointer;
	font-size: 12px;
}

.search-button:hover {
	background-color: #3CA757;
}

#map_view {
	width: 100%;
	height: 100%;
	overflow: hidden;
}
</style>

<style>
/* 覆盖InfoWindow的默认样式 */
.custom-info-window {
	background-color: transparent !important;
	border: none !important;
	box-shadow: none !important;
}

/* 移除InfoWindow的关闭按钮 */
.custom-info-window .tmap-info-window-close {
	display: none !important;
}

/* 移除InfoWindow的箭头 */
.custom-info-window .tmap-info-window-arrow {
	display: none !important;
}

/* 移除InfoWindow的背景 */
.custom-info-window .tmap-info-window-content {
	background-color: transparent !important;
	border: none !important;
	box-shadow: none !important;
}

/* 为车锁编号添加样式，与参考图片一致 */
.custom-info-window .tmap-info-window-content div {
	padding: 4px 8px !important;
	background-color: white !important;
	border: 1px solid #ff6b35 !important;
	border-radius: 4px !important;
	font-size: 12px !important;
	color: #333 !important;
	white-space: nowrap !important;
}
</style>